import type { PublicEvergreenChatConfiguration } from '@/features/webinar/types';

// le chat public ne s'ouvre que sur une config reçue pour la session affichée (absente, en cours, en échec ou d'une autre session : privé)
export function isEvergreenPublicChatRestricted(
  configuration: Pick<PublicEvergreenChatConfiguration, 'publicChatVisible'> | null | undefined,
  configurationSessionIdentifier: string | null | undefined,
  currentSessionIdentifier: string | null | undefined,
): boolean {
  const confirmedForCurrentSession =
    configuration?.publicChatVisible === true &&
    configurationSessionIdentifier != null &&
    configurationSessionIdentifier === currentSessionIdentifier;
  return !confirmedForCurrentSession;
}
